import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Col,
  Layout,
  Select,
  Space,
  Tag,
  Radio,
  Row,
  Checkbox,
  Switch,
  Tooltip
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyTwoTone,
  PlusOutlined,
  DeleteFilled,
  MenuOutlined
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import newDateTime from "controllers/newDateTime";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;
const DragHandle = sortableHandle(({ active }) => (
  <MenuOutlined style={{ cursor: "grab", color: active ? "blue" : "#999" }} />
));
const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);

function SentenceImagePrompt() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [rightBoxRerender, setRightBoxRerender] = useState(false)
  const [languageList, setLanguageList] = useState([]);
  // const [curLanguage, setCurLanguage] = useState("L0010");
  const [fixLanguage, setFixLanguage] = useState(false);
  const [POSList, setPOSList] = useState([])
  const [wordData, setWordData] = useState([])
  const [originWordData, setOriginWordData] = useState([])
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [rightBox, setRightBox] = useState([false, {}]);
  const [rightBoxPreNext, setRightBoxPreNext] = useState([false, false]);
  const [preNext, setPreNext] = useState([false, false]);
  const [editPopup, setEditPopup] = useState([false, {}]);
  const [insertPopup, setInsertPopup] = useState(false);
  const [insertAble, setInsertAble] = useState(true)
  const [nowAble, setNowAble] = useState(0)

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [10, 50, 100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    // filters: {
    //   cefrLevel: "all",
    //   search: "",
    //   language: "L0010"
    // },
  });

  const [wordTableParams, setWordTableParams] = useState({})

  const formRef = useRef(null);
  const rightFormRef = useRef(null);

  const columns = [
    Table.SELECTION_COLUMN,
    {
      title: "순서",
      dataIndex: "",
      width: 80,
      className: "drag-visible",
      render: (d, dd, i) => (
        <>
          <DragHandle active={selectedItems.includes(i)} />
        </>
      ),
    },
    {
      title: "명칭",
      dataIndex: "prompt_name",
      key: "prompt_name",
      width: "120px",
      // sorter: (a,b)=>a.word-b.word,
    },
    {
      title: "프롬프트 갯수",
      dataIndex: "count",
      key: "count",
      width: "160px",
      // sorter: (a,b)=>a.cefr-b.cefr
    },
    {
      title: "디폴트 프롬프트 문장",
      dataIndex: "statement_text",
      key: "statement_text",
      width: "300px",
      // sorter: (a,b)=>a.rowKey-b.rowKey
    },
    {
      title: "처리",
      dataIndex: "",
      width:"150px",
      render: (_, record) => {
        return (
            (record.id === 1 || record.id === 2)
            ? null :
            <div>
              <a
                style={{ margin: "0px 5px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  const rowIdx = record.num;
                  const maxNum = tableParams.pagination.total - 1;
                  const plusNum =
                    (tableParams.pagination.current - 1) *
                    tableParams.pagination.pageSize;
                  const idx = plusNum + rowIdx;
  
                  if (
                    sourceDataKor.length === 1 &&
                    tableParams.pagination.total === 1
                  ) {
                    setPreNext([true, true]);
                  } else if (idx === 0) {
                    setPreNext([true, false]);
                  } else if (idx === maxNum) {
                    setPreNext([false, true]);
                  } else {
                    setPreNext([false, false]);
                  }
                  setRightBox([false,{}])
                  setRowIndex(rowIdx);
                  // console.log(editPopup)
                  setEditPopup([true, record]);
                }}
              >
                수정
              </a>
              <a
                style={{ margin: "0px 5px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteHandler(_);
                }}
              >
                삭제
              </a>
            </div>
        )
      }
    },
    {}
  ];

  const wordColumns = [
    // Table.SELECTION_COLUMN,
    {
      title: "디폴트",
      dataIndex: "default_use_yn",
      key: "default_use_yn",
      width: "50px",
      render: (_,record) => (
        <Switch
          // className="sentenceSwitch"
          defaultChecked={_ === "Y" ? true : false}
          // checkedChildren="편집"
          // unCheckedChildren="운영"
          disabled={record.editable ? (_ === "Y" ? true : false) : true}
          checked={_ === "Y" ? true : false}
          onChange={() => {
            const instance = JSON.parse(JSON.stringify(wordData))

            if(_ === "N") {
              for(let i=0; i<instance.length; i++) {
                if(i === record.num) {
                  instance[i].default_use_yn = "Y"
                } else {
                  if(instance[i].default_use_yn === "Y") {
                    instance[i].default_use_yn = "N"
                    setNowAble(i)
                  }
                }
              }
            } else {
              instance[record.num].default_use_yn = "N"
              instance[nowAble].default_use_yn= "Y"
              setNowAble(0)
            }
            setWordData(instance);
          }}
      ></Switch>
      )
    },
    {
      title: ()=><Tooltip title="변수는 {}로 묶어서 작성해 주세요.">프롬프트 문장</Tooltip>,
      dataIndex: "statement_text",
      key: "statement_text",
      width: "200px",
      render: (_,record) => (
        <Input.TextArea
          autoSize
          style={{
            border: record.editable ? "" : "none",
          }}
          defaultValue={_}
          value={_}
          onChange={(e) => {
            const newText = e.target.value;
            const instance = JSON.parse(JSON.stringify(wordData))
            instance[record.num].statement_text = newText;
            setWordData(instance);
          }}
          onMouseDown={record.editable === true ? ()=>{} : (e)=>{e.preventDefault()}}
          onFocus={() => {
            // compareRef.current = _;
          }}
          onBlur={() => {
            // if (compareRef.current !== _) {
            //   singleChange(_, record, "sentence_text");
            // }
            // compareRef.current = null;
          }}
      ></Input.TextArea>
      )
    },
    {
      title: "기본값",
      dataIndex: "variable_default_value",
      key: "variable_default_value",
      width: "100px",
      // sorter: (a,b)=>a.cefr-b.cefr,
      render: (_,record) => (
        <Input.TextArea
          autoSize
          style={{
            border: record.editable ? "" : "none",
          }}
          defaultValue={_}
          value={_}
          onChange={(e) => {
            const newText = e.target.value;
            const instance = JSON.parse(JSON.stringify(wordData))
            instance[record.num].variable_default_value = newText;
            setWordData(instance);
          }}
          onMouseDown={record.editable === true ? ()=>{} : (e)=>{e.preventDefault()}}
          onFocus={() => {
            // compareRef.current = _;
          }}
          onBlur={() => {
            // if (compareRef.current !== _) {
            //   singleChange(_, record, "sentence_text");
            // }
            // compareRef.current = null;
          }}
        ></Input.TextArea>
      )
    },
    {
      title: "처리",
      dataIndex: "editable",
      width: "100px",
      render: (_, record) => {
        return (
        (record.ContentSettingDALLEPrompt_id === 1 || record.ContentSettingDALLEPrompt_id === 2)
        ? null :
          <div>
            <a
              style={{ margin: "0px 5px" }}
              onClick={(e) => {
                // console.log(wordData)
                // console.log(record)
                // console.log(_)
                e.stopPropagation();
                if(!record.statement_text) {
                  Modal.error({
                    title: "저장 실패",
                    style: { whiteSpace: "pre-line" },
                    okText: "확인",
                    content: "프롬프트 문장은 필수로 입력해야 합니다."
                  })
                  return
                }
                const instance = JSON.parse(JSON.stringify(wordData))
                
                if(_ === true) {
                  console.log(record)
                  axios
                  .patch(`${backend}/contents/content_sentence/image_prompt/statement/${record.id}`, { record })
                  .then(res=>{
                    instance[record.num].editable = false
      
                    //다시 로딩하게 되면 수정중인 다른 데이터가 변하기 때문에 수정된 부분만 현재 데이터에 반영할 필요가 있다.
                    if(record.default_use_yn === "Y") {

                      const originInstance = JSON.parse(JSON.stringify(originWordData))
                      for(let i=0; i<originInstance.length; i++) {
                        originInstance[i].default_use_yn = "N"
                      }
                      if(res.data.data && res.data.data[1]?.insertId) {
                        instance[record.num].id = res.data.data[1]?.insertId
                        originInstance.push(instance[record.num])
                        setInsertAble(true)
                      } else {
                        originInstance.splice(record.num, 1, instance[record.num])
                      }
                      setOriginWordData(originInstance)
                      setWordData(instance);
                    } else {

                      const originInstance = JSON.parse(JSON.stringify(originWordData))
                      if(res.data.data?.insertId) {
                        instance[record.num].id = res.data.data?.insertId
                        originInstance.push(instance[record.num])
                        setInsertAble(true)
                      } else {
                        originInstance.splice(record.num, 1, instance[record.num])
                      }
                      setOriginWordData(originInstance)
                      setWordData(instance);
                    }
                  })
                  .catch(err=>{
                    console.log(err);
                    if (err.response.status === 401) {
                      navigate("/auth");
                    } else {
                      Modal.error({
                        title: "저장 실패",
                        style: { whiteSpace: "pre-line" },
                        okText: "확인",
                        content:err.response.data.message ||
                          "정상적으로 저장되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
                      });
                    }
                  })
                } else {
                  instance[record.num].editable = true
                  setWordData(instance);
                }
              }}
            >
              {_ ? "저장" : "수정"}
            </a>
            <a
              style={{ margin: "0px 5px" }}
              onClick={(e) => {
                e.stopPropagation();
                const instance = JSON.parse(JSON.stringify(wordData))
                const id = record.id

                if(id<0) {
                  instance.splice(record.num,1)
                  setWordData(instance)
                } else {
                  axios
                  .delete(`${backend}/contents/content_sentence/image_prompt/statement/${id}`)
                  .then(res=>{
                    instance.splice(record.num,1)
                    for(let n=0; n<instance.length; n++) {
                      instance[n].num=n
                    }
                    const originInstance = JSON.parse(JSON.stringify(originWordData))
                    
                    //for문이 아니라 while문을 사용하는 것은 삭제 시 originInstance가 영향을 받기 때문
                    let i = 0
                    while(i<originInstance.length) {
                      if(originInstance[i].id === record.id) {
                        originInstance.splice(i,1)
                      } else {
                        originInstance[i].num = i
                        i++
                      }
                    }
                    setOriginWordData(originInstance)
                    setWordData(instance)
                  })
                  .catch(err=>{
                    console.log(err);
                    if (err.response.status === 401) {
                      navigate("/auth");
                    } else {
                      Modal.error({
                        title: "삭제 실패",
                        style: { whiteSpace: "pre-line" },
                        okText: "확인",
                        content:err.response.data.message ||
                          "정상적으로 삭제되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
                      });
                    }
                  })
                }
              }}
            >
              삭제
            </a>
          </div>
        )
      },
    },
 
  ]

  const getSourceData = (data) => {
    // console.log(data)
    const total = data.data.data[1][0]["FOUND_ROWS()"];
    const page = tableParams.pagination.current
    const size = tableParams.pagination.pageSize
    const plusNum = (page-1) * size
    const sourceData = data.data.data[0].map((el,idx)=>{
        // const nameArray = el.ContentSettingErrorTypeMaster_code.split(",").map(el=>{
        //   for(let i=0; i<data.data.data[2].length;i++) {
        //     if(data.data.data[2][i].code === el) {
        //       return data.data.data[2][i].name
        //     }
        //   }
        // })
        
        const rowKey = total - idx -plusNum;
        // el.name = nameArray
        // el.create_datetime = newDateTime(el.create_datetime)
        el.index = el.id
        el.rowKey = rowKey
        el.num = idx
        return el
    })

    setSourceDataKor(sourceData);
    // setLanguageList(data.data.data[2])
    if(editPopup[0] && (rowIndex === 0 || rowIndex === size-1)) {
      setEditPopup([true,sourceData[rowIndex]])
      formRef.current.setFieldsValue(sourceData[rowIndex])
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: total, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
    if(rightBox[0]) {
      const nowNum =
        rowIndex +
        (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
      const max = tableParams.pagination.total - 1;
      
      if(nowNum === 0) {
        setRightBoxPreNext([true,false])
      } else if (nowNum === max) {
        setRightBoxPreNext([false,true])
      } else {
        setRightBoxPreNext([false,false])
      }

      setRightBox([true,sourceData[rowIndex]])
      rightFormRef.current.setFieldsValue(sourceData[rowIndex])
    }
  };

  const getStatementData = (data) => {

    const source = data.data.data.map((el,idx)=>{
      el.num = idx
      el.editable = false
      return el
    })
    setWordData(source)
    setOriginWordData(source)
    // setPOSList(data.data.data[1])
  }

  const merge = (a, b, i = 0) => {
    let aa = [...a];
    return [...a.slice(0, i), ...b, ...aa.slice(i, aa.length)];
  };
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let tempDataSource = sourceDataKor.map((el) => {
      return el;
    });
    if(rowIndex === oldIndex) {
      setRowIndex(newIndex)
    } else if (rowIndex < oldIndex && rowIndex > newIndex) {
      setRowIndex(rowIndex+1)
    } else if (rowIndex > oldIndex && rowIndex < newIndex) {
      setRowIndex(rowIndex-1)
    }
    if (oldIndex !== newIndex) {
      if (!selectedItems.length) {
        let movingItem = tempDataSource[oldIndex];
        tempDataSource.splice(oldIndex, 1);
        tempDataSource = merge(tempDataSource, [movingItem], newIndex);
      } else {
        let filteredItems = [];
        selectedItems.forEach((d) => {
          filteredItems.push(tempDataSource[d]);
        });
        let newData = [];
        tempDataSource.forEach((d, i) => {
          if (!selectedItems.includes(i)) {
            newData.push(d);
          }
        });
        tempDataSource = [...newData];
        tempDataSource = merge(tempDataSource, filteredItems, newIndex);
      }
      // -------------  결과처리 부분 -----------
      let newDataSource = tempDataSource.map((el, idx) => {
        return el.id;
      });
      
      axios.patch(`${backend}/contents/content_sentence/image_prompt/order`,{newDataSource})
      .then(data=>{
        setReRender(!reRender)
        // 이미 변경된 것으로 렌더링이 된 상태이기 때문에 여기에서 다시 렌더링을 시키면 원래대로 돌아갔다가 다시 렌더링 되는 문제가 발생된다.
      })
      .catch(err=>{
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        } else {
          Modal.error({
            title: "순서변경 에러",
            content: "에러가 발생하여 정상적으로 순서를 변경하지 못했습니다.",
            afterClose: () => {
              setRowIndex(oldIndex)
              setSourceDataKor(sourceDataKor);
            },
          });
          console.log(err);
        }
      
      })
      setSourceDataKor(tempDataSource);
      setSelectedItems([]);
    }
  };

  const DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = sourceDataKor.findIndex(
      (x) => x.index === restProps["data-row-key"]
    );
    return (
      <SortableItem
        index={index}
        {...restProps}
        selected={selectedItems.length}
        className={index === rowIndex ? "selectedRow" : null}
        onClick={(e) => {
          onClickDraggable(index)
          if (e.ctrlKey || e.metaKey) {
            selectedItems.includes(index)
              ? selectedItems.splice(selectedItems.indexOf(index), 1)
              : selectedItems.push(index);
            setSelectedItems(selectedItems);
          } else {
            setSelectedItems([]);
          }
        }}
      />
    );
  };

  const statusFilter = (value) => {
    // console.log(value)
    setRowIndex(null);
    setRightBox([false, {}]);
    setTableParams({
        ...tableParams,
        pagination:{...tableParams.pagination, current:1},
        filters:{
            ...tableParams.filters,
            status: value
        }
    })
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
        ...tableParams,
        pagination,
        sorter
      });
      if (pagination.pageSize !== tableParams.pagination?.pageSize) {
        setSourceDataKor([]);
      }
      setRightBox([false,{}])
      setRowIndex(null)
  };

  const handleWordTableChange = (pagination, filters, sorter) => {
    setWordTableParams({
      ...wordTableParams,
      sorter
    })
  }
  // const copyToClipboard = () => { // https에서만 지원함
  //   const text = document.querySelector("#sentence").value
  //   window.navigator.clipboard.writeText(text)
  // }
  const copyToClipboard = () => {
      const text = document.querySelector("#sentence").value
      const tempElem = document.createElement('textarea');
      tempElem.value = text;  
      document.body.appendChild(tempElem);
    
      tempElem.select();
      document.execCommand("copy");
      document.body.removeChild(tempElem);
  }

  const insertOkHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .post(`${backend}/contents/content_sentence/image_prompt`, { value })
      .then((data) => {
        setReRender(!reRender);

        Modal.success({
          title: "등록 완료",
          okText: "확인",
          content: "정상적으로 등록되었습니다.",
          afterClose: () => {
            setInsertPopup(false);
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const insertOkNextHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .post(`${backend}/contents/content_sentence/image_prompt`, { value })
      .then((data) => {
        formRef.current.resetFields()
        setReRender(!reRender);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const editOkHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .patch(`${backend}/contents/content_sentence/image_prompt/${value.id}`, { value })
      .then((data) => {
        setReRender(!reRender)
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
          afterClose:()=>{setEditPopup([false,{}])}
        });
      })
      .catch((err) => {
        console.log(err);
        Modal.error({
          title: "수정 실피",
          okText: "확인",
          content:
            "정상적으로 수정되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
        });
      });
  };

  const preRecord = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setPreNext([false, false]);
    }
    if (preNum === 0) {
      setPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // console.log(rowIndex)
    // console.log(preNum,plusNum)
    if (rowIndex === 0) {
      formRef.current.setFieldValue("num", preNum - plusNum);
    } else {
      setEditPopup([true, data[preNum - plusNum]]);
      formRef.current.resetFields();
      formRef.current.setFieldsValue(data[preNum - plusNum]);
    }

  }

  const nextRecord = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setPreNext([false, false]);
    }
    if (nextNum === max) {
      setPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);
    if (nextNum - plusNum === 0) {
      formRef.current.setFieldValue("num", nextNum - plusNum);
    } else {
      setEditPopup([true, data[nextNum - plusNum]]);
      formRef.current.resetFields();
      formRef.current.setFieldsValue(data[nextNum - plusNum]);
    }
  }

  const deleteHandler = (_) => {
    setLoading(true)
    setRightBox([false,{}])
    let deleteKeys = []
    let containPrompt = _.count ? true : false
    if(_.id) {
      deleteKeys.push(_.id)
    } else {
      deleteKeys = selectedKeys.filter(el=>el !== 1 && el !== 2)
      for(let i = 0; i < selectedRows.length; i++) {
        if(selectedRows[i].count) {
          containPrompt = true
          break;
        }
      }
    }

    const onOk = () => {
      axios
        .delete(`${backend}/contents/content_sentence/image_prompt/${deleteKeys}`)
        .then(res=>{
          setReRender(!reRender)
          setLoading(false)
          setSelectedKeys([])
          setSelectedRows([])
          setRowIndex(null)
          Modal.success({
            title: "삭제 완료",
            okText: "확인",
            content: "정상적으로 삭제되었습니다.",
          });
        })
        .catch(err=>{
          console.log(err)
          setLoading(false)
          Modal.error({
            title: "삭제 실피",
            okText: "확인",
            content:
              "정상적으로 삭제되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
          });
        })
    }

    Modal.confirm({
      style: { whiteSpace: "pre-line" },
      title: "경고",
      content:
        containPrompt ? "선택한 프롬프트에 여러가지 문장이 등록되어 있습니다. \n프롬프트를 삭제할 경우 모두 삭제됩니다." : "선택한 프롬프트를 삭제하시겠습니까?",
      okText: "확인",
      okType: containPrompt ? "default" : "primary",
      autoFocusButton: containPrompt ? "cancel" : "ok",
      cancelButtonProps: {type: containPrompt ? "primary" : "default"},
      // cancelButtonProps: containPrompt ? {style:{background:"#1890ff", border:"#1890ff", color:"#fff"}} : null,
      cancelText: "취소",
      onOk: onOk,
      onCancel: ()=>setLoading(false)
    });
  };

  const onRow = (record, rowIdx) => {
    return {
      onClick: () => {
        const data = sourceDataKor;
        const maxNum = tableParams.pagination.total - 1;
        const plusNum =
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize;
        const idx = plusNum + rowIdx;

        if (data.length === 1 && tableParams.pagination.current === 1) {
          setRightBoxPreNext([true, true]);
        } else if (idx === 0) {
          setRightBoxPreNext([true, false]);
        } else if (idx === maxNum) {
          setRightBoxPreNext([false, true]);
        } else {
          setRightBoxPreNext([false, false]);
        }
        setRowIndex(rowIdx);
        // setCurLanguage(data[idx].SystemSettingLanguage_code);
        setRightBox([true, data[rowIdx]]);
        if (rightBox[0]) {
          rightFormRef.current.setFieldsValue(data[rowIdx]);
        }
      },
    };
  };

  const onClickDraggable = (rowIdx) => {
    const data = sourceDataKor;
    const maxNum = tableParams.pagination.total - 1;
    const plusNum =
      (tableParams.pagination.current - 1) *
      tableParams.pagination.pageSize;
    const idx = plusNum + rowIdx;

    if (data.length === 1 && tableParams.pagination.current === 1) {
      setRightBoxPreNext([true, true]);
    } else if (idx === 0) {
      setRightBoxPreNext([true, false]);
    } else if (idx === maxNum) {
      setRightBoxPreNext([false, true]);
    } else {
      setRightBoxPreNext([false, false]);
    }
    setRowIndex(rowIdx);
    // setCurLanguage(data[idx].SystemSettingLanguage_code);
    if(data[rowIdx].id === 1 || data[rowIdx].id === 2) {
      setRightBox([false,{}]);
    } else {
      setRightBox([true, data[rowIdx]]);
    }
    if (rightBox[0]) {
      rightFormRef.current.setFieldsValue(data[rowIdx]);
    }
  }

  const onSearch = (value) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current:1
      },
      filters: {
        ...tableParams.filters,
        search: value
      }
    })
    setRightBox([false,{}])
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  }

  const cefrFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current:1
      },
      filters: {
        ...tableParams.filters,
        cefrLevel: value
      }
    })
    setRightBox([false,{}])
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  }

  const languageFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current:1
      },
      filters: {
        ...tableParams.filters,
        language: value
      }
    })
    setRightBox([false,{}])
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  }

  const resetValueRight = () => {
    setWordData(originWordData)
    setLoading(false)
  };

  const editCancelHandlerRight = () => {
    setRightBox([false, {}]);
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  };

  // // 이전 버튼 클릭 시 작동 함수
  const preRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setRightBoxPreNext([false, false]);
    }
    if (preNum === 0) {
      setRightBoxPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // setCurLanguage(data[preNum].SystemSettingLanguage_code);

    if (rightBox[0]) {
      if (rowIndex === 0) {
        rightFormRef.current.setFieldValue("num", preNum - plusNum);
      } else {
        setRightBox([true, data[preNum - plusNum]]);
        rightFormRef.current.resetFields();
        rightFormRef.current.setFieldsValue(data[preNum - plusNum]);
      }
    }
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setRightBoxPreNext([false, false]);
    }
    if (nextNum === max) {
      setRightBoxPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);

    if (rightBox[0]) {
      if (nextNum - plusNum === 0) { //마지막 번호라서 다음 페이지로 넘어가야 할 때
        rightFormRef.current.setFieldValue("num", nextNum - plusNum);
      } else {
        setRightBox([true, data[nextNum - plusNum]]);
        rightFormRef.current.resetFields();
        rightFormRef.current.setFieldsValue(data[nextNum - plusNum]);
      }
    }
  };


  useEffect(() => {
    setLoading(true);
    const { current, pageSize } = tableParams.pagination;
    // const sorterCol = tableParams.sorter?.column?.dataIndex || "id"
    // const sorterDirection = tableParams.sorter?.order === "ascend" ? "ASC" : "DESC"

    axios
      .get(`${backend}/contents/content_sentence/image_prompt/list?current=${current}&pageSize=${pageSize}`)
      .then((data) => {
        getSourceData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, 
  [
    // JSON.stringify(tableParams.filters),
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    // JSON.stringify(tableParams.sorter),
    originWordData,
    reRender
  ]);

  useEffect(()=>{
    if(rightBox[0]) {

      // const SystemSettingLanguage_code = tableParams.filters.language
      // const sorterCol = wordTableParams.sorter?.column?.dataIndex || "id"
      // const sorterDirection = wordTableParams.sorter?.order === "descend" ? "DESC" : "ASC"

      const id = rightBox[1].id
      axios
        .get(`${backend}/contents/content_sentence/image_prompt/statement_list/${id}`)
        .then(res=>{
          getStatementData(res)
          setLoading(false)
        })
        .catch(err=>{
          console.log(err)
          setLoading(false)
        })
    }
  },[rightBox[1].num, JSON.stringify(wordTableParams),rightBoxRerender])

  useEffect(()=>{
    if(!insertAble) {
      const able = wordData.filter(el=>el.id<0)
      if(able.length === 0) {
        setInsertAble(true)
      }
    }
  },[wordData])

//   useEffect(() => {
//     if (rightBox[0]) {
//       const num = rightFormRef.current.getFieldValue("num");
//       rightFormRef.current.setFieldsValue(sourceDataKor[num]);
//     }
//   }, [sourceDataKor]);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
       <Modal
        destroyOnClose={true}
        open={insertPopup}
        title="프롬프트 명칭 등록"
        maskClosable={false}
        onCancel={() => setInsertPopup(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                onClick={insertOkHandler}
                icon={<CheckOutlined />}
              >
                등록
              </Button>
              <Button onClick={insertOkNextHandler} icon={<CheckOutlined />}>
                등록 후 계속
              </Button>
              <Button
                onClick={() => setInsertPopup(false)}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
        >
          <Form.Item
            name="prompt_name"
            label="명칭"
            required={true}
            rules={[{ required: true, message: "명칭은 필수값입니다." }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={editPopup[0]}
        title="프롬프트 명칭 수정"
        maskClosable={false}
        onCancel={() => {setEditPopup([false, {}]);setRowIndex(null)}}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                onClick={preRecord}
                disabled={preNext[0]}
                icon={<LeftOutlined />}
              >
                이전
              </Button>
              <Button
                type="primary"
                onClick={editOkHandler}
                icon={<CheckOutlined />}
              >
                수정
              </Button>
              <Button
                onClick={nextRecord}
                disabled={preNext[1]}
                icon={<RightOutlined />}
              >
                다음
              </Button>
              <Button
                onClick={() => {setEditPopup([false, {}]);setRowIndex(null)}}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
          initialValues={editPopup[1]}
        >
          <Form.Item
            name="id"
            hidden = {true}
          ></Form.Item>
          <Form.Item
            name="prompt_name"
            label="명칭"
            required={true}
            rules={[{ required: true, message: "명칭 필수값입니다." }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>프롬프트 목록</span>
        <Space wrap>
          {/* <Input.Search
            placeholder="영어 단어를 입력하세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px",
            }}
          />
          <Select
            options={languageList}
            defaultValue={"L0010"}
            onChange={languageFilter}
          ></Select>
          <Select
            options={[
              {label:"전체", value:"all"},
              {label:"A0", value:"A0"},
              {label:"A1", value:"A1"},
              {label:"A2", value:"A2"},
              {label:"B1", value:"B1"},
              {label:"B2", value:"B2"},
              {label:"C1", value:"C1"},
              {label:"C2", value:"C2"},
            ]}
            style={{ width: 130, textAlign: "left" }}
            defaultValue="CEFR Level"
            // value={tableParams.filters.languageFilter}
            onChange={cefrFilter}
          ></Select> */}
          <Button onClick={() => setInsertPopup(true)}>
            <PlusOutlined />
            프롬프트 명칭 추가
          </Button>
        </Space>
      </div>
      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
       
        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            className="pageTable"
            rowSelection={{
              selectedRowKeys: selectedKeys,
              onChange: (keys, rows) => {
                setSelectedRows(rows.sort((a, b) => a.num - b.num));
                setSelectedKeys(keys.sort((a, b) => a - b));
              },
              getCheckboxProps: (record) => ({
                disabled: record.id === 1 || record.id === 2 ? true : false, // 특정 조건일 경우 사용하지 체크하지 못하도록 함
                // className: record.hideCheckbox ? "hidden-checkbox" : "" // 클래스 설정 가능
          
              })
            }}
            // onRow={onRow} //draggable에서 해야 함.
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            columns={columns}
            rowKey="id"
            dataSource={sourceDataKor}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x:100, y:"100%"}}
            components={{
              body: {
                wrapper: DraggableContainer,
                row: DraggableBodyRow,
              },
            }}
            footer={() => (
              <div style={{ textAlign: "left" }}>
                <Space>
                  <Button onClick={deleteHandler} disabled={selectedKeys.length === 0}>
                    <DeleteFilled />
                    선택한 프롬프트 삭제
                  </Button>
                </Space>
            </div>
          )}
          />
        </Col>
        {rightBox[0] ? (
          <Col
            flex={0}
            style={{
              minWidth: "500px",
              border: "1px whitesmoke solid",
              marginLeft: "10px",
              height: "100%",
              overflow:"auto"
            }}
          >
            <div
              style={{
                padding: "10px",
                borderBottom: "1px whitesmoke solid",
                fontWeight: 700,
                fontSize: 17,
                textAlign: "left",
              }}
            >
              프롬프트 문장 목록
            </div>
            <Layout.Content style={{ padding: "10px" }}>
              <Form
                ref={rightFormRef}
                layout="vertical"
                initialValues={rightBox[1]}
              >
                <Form.Item name="id" label="id" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="rowKey" label="rowKey" hidden={true}>
                  <Input></Input>
                </Form.Item>
                <Form.Item name="num" label="num" hidden={true}>
                  <Input></Input>
                </Form.Item>
                {/* <Form.Item name="ContentSentenceMaster_id" hidden={true}>
                  <Input></Input>
                </Form.Item> */}
                {/* <Form.Item name="word" label="단어">
                  <Input
                    id="sentence"
                    disabled
                    suffix={<CopyTwoTone onClick={copyToClipboard} style={{cursor:"pointer"}}/>}
                  ></Input>
                </Form.Item> */}
              </Form>
              <Col flex={1} style={{ minWidth: "100px" }}>
                <StyledTable
                  // className="pageTable"
                  // onRow={onRow}
                  // rowClassName={(record, index) => {
                  //   return index === rowIndex ? "selectedRow" : "";
                  // }}
                  // rowSelection={{
                  //   selectedRowKeys: selectedKeys,
                  //   onChange: (keys, rows) => {
                  //     setSelectedRows(rows.sort((a, b) => a.num - b.num));
                  //     setSelectedKeys(keys.sort((a, b) => a - b));
                  //   },
                  // }}
                  columns={wordColumns}
                  rowKey="id"
                  dataSource={wordData}
                  loading={loading}
                  pagination={false}
                  onChange={handleWordTableChange}
                  scroll={{ x:100, y:"100%"}}
                  footer={() => (
                    <div style={{ textAlign: "left" }}>
                      <Space>
                        {
                          (rightBox[1].id === 1 || rightBox[1].id === 2)
                          ? null :
                          <Button
                            disabled={!insertAble}
                            onClick={() => {
                              const ContentSettingDALLEPrompt_id = rightBox[1].id
                              // axios
                              // .post(`${backend}/contents/content_sentence/prompt/statement/${id}`)
                              // .then(res=>{
                              //   console.log(res)
                              // })
                              // .catch(err=>{
                              //   console.log(err)
                              // })
                              const newNum = wordData.length
                              const randomID = parseInt(Math.random()*-1000000)
                              const instance = JSON.parse(JSON.stringify(wordData))
                              instance.push({
                                ContentSettingDALLEPrompt_id: ContentSettingDALLEPrompt_id,
                                create_datetime: null,
                                default_use_yn: newNum === 0 ? "Y" : "N",
                                editable: true,
                                id: randomID,
                                num: newNum,
                                statement_text: null,
                                update_datetime: null,
                                variable_default_value: null
                              })
                              setWordData(instance)
                              setInsertAble(false)
                            }}
                          >
                            <PlusOutlined />
                            프롬프트 문장 추가
                          </Button>
                        }
                      </Space>
                  </div>
                )}
                />
              </Col>
            </Layout.Content>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                borderTop: "1px whitesmoke solid",
              }}
            >
              <Button onClick={resetValueRight}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecordRight}
                  disabled={rightBoxPreNext[0] || loading}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                {/* <Button
                  style={{ marginLeft: "5px" }}
                  type="primary"
                  onClick={editOkHandlerRight}
                  disabled={loading || JSON.stringify(wordData) === JSON.stringify(originWordData)}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button> */}
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={nextRecordRight}
                  disabled={rightBoxPreNext[1] || loading}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={editCancelHandlerRight}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          </Col>
        ) : null}

      </div>
    </div>
  );
}

export default SentenceImagePrompt;
